import { createAsyncThunk } from '@reduxjs/toolkit';
import { getScopedWarehousesRequest } from './warehouseContextApi';
import { extractApiError } from '../../utils/errors';

/**
 * Loads the warehouses of the session. One call feeds both filters of the
 * module: which warehouse, and which client inside it.
 *
 * @returns {Promise<Array<object>>}
 */
export const fetchScopedWarehouses = createAsyncThunk(
  'warehouseContext/fetchScopedWarehouses',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getScopedWarehousesRequest();
      return response.data?.warehouses || [];
    } catch (error) {
      console.error('Error fetching scoped warehouses:', error);
      return rejectWithValue(extractApiError(error, 'No se pudieron obtener las bodegas'));
    }
  }
);
